import { render, staticRenderFns } from "./AttachmentsForm.vue?vue&type=template&id=531f27e0&scoped=true"
import script from "./AttachmentsForm.vue?vue&type=script&lang=js"
export * from "./AttachmentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f27e0",
  null
  
)

export default component.exports